import unescape from 'lodash/unescape';
const planImpactFormatter = (escapedString) => {
  const string = unescape(escapedString).replace('&mdash;', '—');
  if (string.match(/^\s*[$]([0-9]*[,])*[0-9]*\s*$/)) {
    const { ADV } = window;
    const number = ADV.util.numberFrom(string).toString();
    const strippedOfSeparatorsAndDecimals = number.replace(/[.,]/g, '');
    const endings = ['K', 'MM', 'B', 'T', 'Q'];
    if (strippedOfSeparatorsAndDecimals.length > 5) {
      return `$${ADV.util.short_number_format(
        ADV.util.numberFrom(string),
        2,
        [''].concat(endings),
      )}`;
    }
    return `$${ADV.util.number_format(strippedOfSeparatorsAndDecimals, 0)}`;
  }
  return string;
};

export default planImpactFormatter;
